import { supabase } from "../../../app/supabaseClient";
import supabaseApi from "../supabaseSlice";

const locationsApi = supabaseApi.injectEndpoints({
  endpoints: (build) => ({
    getLocations: build.query({
      queryFn: async () => {
        const { data, error } = await supabase
          .from("locations")
          .select("*");
        const response = data.sort((a, b) => {
          if (a.location === "Crown Heights") return -1;
          if (b.location === "Crown Heights") return 1;
          return a.location.localeCompare(b.location);
        });
        if (error) throw { error };
        return { data: response };
      },
    }),
    getAllLocations: build.query({
      queryFn: async () => {
        const { data, error } = await supabase.from("locations").select("*");
        if (error) throw { error };
        const response = data.sort((a, b) => {
          if (a.location === "Crown Heights") return -1;
          if (b.location === "Crown Heights") return 1;
          return a.location.localeCompare(b.location);
        }
        );
        return { data: response };
      },
    }),
  }),
});

export const {
  useGetLocationsQuery,
  useLazyGetLocationsQuery,
  useGetAllLocationsQuery,
} = locationsApi;
